import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { GET_PI_LIST_TO_MODIFY, updatePIlogUrl, UPDATE_PI_LOG, getProformaInvLogListUrl, headers } from "../../../utils/constants";



export const getProformaInvLogList_action = () => async (dispatch) => {

    try {
        const params = {
            Userid: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            // AccountID: JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(getProformaInvLogListUrl, params, headers)

        dispatch({
            type: GET_PI_LIST_TO_MODIFY,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updatePIlog_action = (ExhRegistrationID, ExhibitionID, ExhibitionStallSizeID, StallArea, StallDimension, StallTypeID, isSSICertified) => async (dispatch) => {

    try {
        const mapData = {
            ExhibitionID: ExhibitionID,
            StallTypeID: StallTypeID,
            StallDimension: StallDimension,
            StallArea: StallArea,
            ExhibitionStallSizeID: ExhibitionStallSizeID,
            ExhRegistrationID: ExhRegistrationID,
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            isSSICertified: isSSICertified
        }
        console.log("Space Booking Action ----->", mapData)
        const res = await axiosPost(updatePIlogUrl, mapData, headers)

        dispatch({
            type: UPDATE_PI_LOG,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }

}
